import { useQuery } from "@tanstack/react-query";
import { SelectBox, TagBox } from "@monolith-forensics/monolith-ui";
import { EventTypesAPI } from "@/Features";

const TimelineEventTypeSelector = ({ multiple = false, ...props }) => {
  const { data, isLoading } = useQuery({
    queryKey: EventTypesAPI.queryKey,
    queryFn: () => EventTypesAPI.get(),
  });

  const records =
    data?.map?.((item) => ({
      label: item.event_type,
      value: item.event_type_id,
      data: item,
    })) || [];

  if (multiple) {
    return <TagBox {...props} loading={isLoading} data={records} />;
  }

  return <SelectBox {...props} loading={isLoading} data={records} />;
};

export default TimelineEventTypeSelector;
